
import 'react-quill/dist/quill.bubble.css';
import './AODetails.scss';
import './Alertes.scss';

import { RemoveRedEye, Star } from '@mui/icons-material';
import ChatIcon from '@mui/icons-material/Chat';
import EqualizerIcon from '@mui/icons-material/Equalizer';
import {
    Button,
    IconButton,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

import DialogCommentPriveCv from '../../../Components/Dialogs/DialogCommentPriveCv';
import DialogMatchingScore from '../../../Components/Dialogs/DIalogMatchingScore';
import DialogTransmettreCv from '../../../Components/Dialogs/DialogTransmettreCv';
import CvAnonyme, { getMyNote } from '../../../Components/Docs/CvAnonyme';
import { buttonStyles } from '../../../Components/docsAdministrative/JsObjectStyles';
import ChangeStatusCandidature from '../../../Components/shared/ChangeStatusCandidature';
import { MaterialTableComponent } from '../../../Components/shared/ReusableSmallComponents';
import { fluxCandidature, genreTitres } from '../../../data/Interfaces';
import useAuth from '../../../hooks/useAuth';
import useAxiosPrivate from '../../../hooks/useAxiosPrivate';
import useGetRequest from '../../../hooks/useGetRequest';
import { useNumberFormatting } from '../../../hooks/useNumberFormatting';
import usePostRequest from '../../../hooks/usePostRequest';
import useRole from '../../../hooks/useRole';
import useUtilities from '../../../hooks/useUtilities';
//import useWindowSize from '../../../hooks/useWindowSize';
//import { notSelectedFrameCvTheque, selectedFrameCvTheque } from '../../../Styles/componentStyles';
import { formatDateJJMMYYYY } from '../../../Utils/dateFormatter';
import { calculateTotalAnneeExperience, getDateDisponibilite, getNomPrenomAnonymeFromPersoData, isUrlFromCandidature, searchLabelInEnumByValue, UpperCasePrenomNom } from '../../../Utils/utils';
import { getPaymentSimulationResults } from '../../../Utils/utilsCraX';

export default function AODetails() {
    const { addEuro4Decimal } = useNumberFormatting();

    const axiosPrivate = useAxiosPrivate();
    const { auth } = useAuth();
    const role = useRole();
    let param = useParams();
    //const {device}=useWindowSize();
    const { postData } = usePostRequest();
    const { setBackdropOpen } = useUtilities();
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const { data: ao, refresh } = useGetRequest({ url: `/ao/getMyAoById/${param?.aoId}`, propertyName: 'myAO' });
    const [expert, setExpert] = useState();
    const [expertId, setExpertId] = useState();
    const [selectedCandidature, setSelectedCandidature] = useState();
    const [candidaturesArray, setCandidaturesArray] = useState([]);
    const [openCvAnonyme, setOpenCvAnonyme] = React.useState(false);
    const [openDialogCommentPriveCv, setOpenDialogCommentPriveCv] = useState(false);
    const [openDialogTransmettreCv, setOpenDialogTransmettreCv] = useState(false);
    const [openDialogMatchingScore, setOpenDialogMatchingScore] = useState(false);
    const [selectedRow, setSelectedRow] = React.useState(null);
    const [statusCandidatures, setStatusCandidatures] = useState([]);
    const { i18n } = useTranslation();

    const handleStatusChange = (index, newStatus) => {
        setStatusCandidatures(prevStatuses => {
            const updatedStatuses = [...prevStatuses];
            updatedStatuses[index] = newStatus;
            return updatedStatuses;
        });
    };
    const checkUnreadStatus = (index, aoId, expertId, status) => {
        if (status == 'unread') {
            //add condition (if status of updateCandidatureStatus ==success than we  handleStatusChange)
            updateCandidatureStatus('analyzed', aoId, expertId);
            handleStatusChange(index, 'analyzed');
        }
    };

    useEffect(async () => {
        if (ao) {
            setBackdropOpen(true);
            let Array1 = [];
            const newCandidaturesWithMatching = await getMatching(ao?.candidatures);
            //Sort the dataArray based on the "matchingScore" field in descending order
            if(newCandidaturesWithMatching){
                newCandidaturesWithMatching.sort((a, b) => b.matchingScore - a.matchingScore);
                newCandidaturesWithMatching.map((candidat, index) => {
                    // ao?.candidatures.reverse().map((candidat,index) => {
                    handleStatusChange(index, candidat?.status);
                    Array1.push({
                        'index': index,
                        'titre': i18n.t(searchLabelInEnumByValue(genreTitres, candidat?.expertId?.persoData?.genre)),
                        'nomMasque': role == 'admin' ? UpperCasePrenomNom(candidat?.expertId?.persoData) : getNomPrenomAnonymeFromPersoData(candidat?.expertId?.persoData),
                        'refExpert': candidat?.expertId?.expertId,  // or collaborator ID if expertId doesn't exist
                        'flux': candidat?.flux,
                        'intitulePoste': candidat?.expertId?.persoData?.intitulePoste,
                        'dateDispo': (getDateDisponibilite(candidat?.dateDisponibilite) == '_______' && candidat?.flux == 'cvtheque') ? getDateDisponibilite(candidat?.expertId?.preference?.dateDisponibilite) : getDateDisponibilite(candidat?.dateDisponibilite),
                        'totalExp': candidat?.expertId?.proData?.otherInfo?.totalAnneeExperience ?? calculateTotalAnneeExperience(candidat?.expertId?.proData?.experiences),
                        'tjClient': getPaymentSimulationResults({ tj: candidat?.tj, commissionHTH: 0.2 })?.tjClient || getPaymentSimulationResults({ tj: candidat?.expertId?.preference?.tjm, commissionHTH: 0.2 })?.tjClient,
                        'localisation': candidat?.expertId?.preference?.residence?.ville + '/' + candidat?.expertId?.preference?.residence?.pays,
                        'argumentCommer': candidat?.argumentCommercial,
                        'createdAt': candidat?.createdAt,
                        'recommandation': candidat?.expertId?.recommendation?.cercle,
                        ...candidat
                    });
                });
            }
            setCandidaturesArray(Array1);
            setBackdropOpen(false);
        }
    }, [ao]);

    const updateCandidatureStatus = async (currentStatus, aoId, expertId) => {
        try {
            const response1 = await axiosPrivate.post('/candidature/updateCandidatureStatus',
                {
                    expertId,
                    'statusCandidature': currentStatus,
                    // * AO context
                    aoId,
                }
            );
            const responseData1 = await response1.data;
            console.log('submitresumeBackend', responseData1, responseData1?.message);
            //! we can't see the alert componenet above Dialog
        } catch (error) {
            console.log(error.response?.status);

        }
    };

    //const [selectedExperts,setSelectedExperts]=useState([]);
    const ExpertsColumns = [
        {
            field: 'matchingScore',
            title: i18n.t('Matching'),
            render: (rowData) => {
                return (
                    <>
                        <Button
                            onClick={() => {
                                setSelectedCandidature(rowData);
                                setOpenDialogMatchingScore(true);
                            }}
                        >
                            {addEuro4Decimal((rowData?.matchingScore * 100).toFixed(2), '%')}
                            <EqualizerIcon />
                        </Button>
                    </>
                // <Tooltip title={<span dangerouslySetInnerHTML={{ __html: getInfoScoreMatching(rowData) }}></span>}>
                //     {addEuro4Decimal((rowData?.matchingScore * 100).toFixed(2), '%')}
                // </Tooltip>
                );
            }
        },
        {
            field: 'eye',
            title: i18n.t('CV'),
            render: rowData =>
                <RemoveRedEye
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                        console.log({ RemoveRedEye: rowData });
                        setSelectedCandidature(rowData);
                        setOpenCvAnonyme(true);
                        setExpertId(rowData?.expertId?._id ?? rowData?.esnExpertOwnerId?._id);
                        setExpert(rowData?.expertId);
                        checkUnreadStatus(rowData?.index, rowData?.aoId, rowData?.expertId, rowData?.status);
                    }}
                />
        },
        {
            field: 'refExpert',
            title: i18n.t('Réf.expert'),
        },
        {
            field: 'titre',
            title: i18n.t('Titre'),
        },
        {
            field: 'nomMasque',
            title: i18n.t('Nom'),
        },
        {
            field: 'flux',
            title: i18n.t('Source de candidature'),
            render: (rowData) => {
                return <>
                    {i18n.t(searchLabelInEnumByValue(fluxCandidature, rowData?.flux))}
                </>;
            }
        },
        {
            field: 'intitulePoste',
            title: i18n.t('Intitulé du CV'),
        },
        {
            field: 'totalExp',
            title: i18n.t('Exp. totale'),
            render: rowData =>
                addEuro4Decimal(rowData?.totalExp, ' ans')
        },
        {
            field: 'statut',
            title: i18n.t('Statut Candidatures'),
            render: rowData => {
                // console.log({ 'Statut Candidatures':rowData });
                return (
                    <ChangeStatusCandidature
                        width={'170px'}
                        defaultStatusCandidat={statusCandidatures[rowData?.index]}
                        setStatusCandidature={newStatus => handleStatusChange(rowData?.index, newStatus)}
                        expertId={rowData?.expertId?._id}
                        aoId={rowData?.aoId}
                    />
                );
            }
        },
        {
            field: 'dateDispo',
            title: i18n.t('Date de disponibilité'),
            render: (rowData)=>
                i18n.t(rowData?.dateDispo)
        },
        {
            field: 'tjClient',
            title: i18n.t('Taux journalier'),
            render: rowData => {
                return addEuro4Decimal(rowData?.tjClient);
            }
        },
        {
            field: 'localisation',
            title: i18n.t('Ville/Pays'),
        },
        {
            field: 'evaluation',
            title: i18n.t('Evaluation'),
            render: (rowData) => {
                return <>
                    {/* //faut ajouter un traitement selon la notation du client soit on affiche start ou half start */}
                    {getMyNote({ noteList: rowData?.note, collaboratorId: auth?.collaboratorId })?.evaluation ?
                        <>
                            {getMyNote({ noteList: rowData?.note, collaboratorId: auth?.collaboratorId })?.evaluation}
                            <Star style={{ color: '#faaf00' }} />
                        </>
                        : (getMyNote({ noteList: rowData?.note }) ?
                            <>
                                {getMyNote({ noteList: rowData?.note })}
                                <Star style={{ color: '#faaf00' }} />
                            </>
                            : null)}
                </>;
            }
        },
        {
            field: 'commentaire',
            title: i18n.t('Commentaires'),
            render: rowData =>
                <IconButton
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                        setSelectedCandidature(rowData);
                        setOpenDialogCommentPriveCv(true);
                    }}
                >
                    <ChatIcon />
                </IconButton>
        },
        {
            field: 'createdAt',
            title: i18n.t('Date de candidature'),
            render: (rowData) => {
                return <>
                    {formatDateJJMMYYYY(rowData?.createdAt)}
                </>;
            }
        },
    ];

    const getMatching = async (candidaturesArrayTemp) => {
        // TODO: new logic : check if at least one of candidature has not a matching value, then call the api and update all of them
        // const hasNoMatchingValue = !candidaturesArrayTemp.some(candid => candid.matchingScore);
        // const hasNoMatchingValue = hasCandidatureWithoutMatchingScore(candidaturesArrayTemp);
        // const hasMatchingValue = candidaturesArrayTemp.some(candid => candid.matchingScore);
        // alert(JSON.stringify({hasNoMatchingValue, hasMatchingValue}));
        if (hasCandidatureWithoutMatchingScore(candidaturesArrayTemp) && candidaturesArrayTemp.length > 0) {
            console.log('#####', hasCandidatureWithoutMatchingScore(candidaturesArrayTemp));
            try {
                const response = await axiosPrivate.post('/proxy/ranking_resumes', {
                    ao_id: param?.aoId
                });

                const responseData = response.data;
                candidaturesArrayTemp.forEach(candidature => {
                    const matchingCandidature = responseData.find(item => item.candidature_id === candidature._id);

                    if (matchingCandidature) {
                        candidature.matchingScore = matchingCandidature.matching_score;
                        candidature.funcSkillsScore = matchingCandidature.fonc_skills_score;
                        candidature.techSkillsScore = matchingCandidature.tech_skills_score;
                        candidature.experienceScore = matchingCandidature.experience_score;
                        candidature.langueScore = matchingCandidature.langue_score;
                        candidature.certifScore = matchingCandidature.certif_score;
                    }
                });
                // The `candidaturesArray` will now have the updated attributes based on the matching `_id` and `candidature_id`
                console.log(candidaturesArrayTemp);
                // setCandidaturesArray(candidaturesArrayTemp);
                // const updateScore =
                await postData({
                    url: '/candidature/updateCandidaturesScore',
                    payload: {
                        candidaturesArray: candidaturesArrayTemp
                    }
                });
                // console.log(updateScore);
                return candidaturesArrayTemp;
            } catch (error) {
                console.error('Error sending request:', error);
            }
        }
        // * all candidatures has a matching score
        else return candidaturesArrayTemp;
    };
    const hasCandidatureWithoutMatchingScore = (candidaturesArrayTemp) => {
        return candidaturesArrayTemp.some(candidature => {
            console.log('$$$',  (!candidature.matchingScore && candidature.matchingScore !== 0) , candidature );
            return !candidature?.matchingScore && candidature?.matchingScore !== 0;
        } );
    };
    return (
        <div className='frame0AODetails'>
            <div className='frame5Profile'>{(role=='esn' ? i18n.t('Mes Appels d\'offres') : i18n.t('Appels d\'offres'))} &gt; <span style={{ color: 'rgba(39, 45, 60, 1)' }}> {isUrlFromCandidature(pathname) ? i18n.t('Mes candidatures') : i18n.t('AO et candidatures')} </span> </div>
            <div className='frame1AODetails'>
                <div className='frame2AODetails'>
                    <h6 className='frame3AODetails'>{ao?.intitulePoste}</h6>
                    <p className='frame4AODetails'>
                        {i18n.t('Réf.AO')} {ao?.tjMax !== undefined }
                        {' ' + ao?.aoId + ' '}
                        {i18n.t('TJ max')}
                        {(ao?.tjMax !== undefined && ao?.tjMax ) ?
                            ' '+ao?.tjMax + ' €  '
                            :
                            ' Non précisé  '}
                        - {i18n.t('Date début souhaitée')}
                        {' ' + formatDateJJMMYYYY(ao?.dateDebutMission)}
                    </p>
                </div>

                {/*Masquer pour la V1
                <div className='frame5AODetails'>
                    <div className='frame8AODetails'>
                        <Button
                            onClick={() => setOpenDialogTransmettreCv(true)}
                            variant="contained"
                            disabled={(selectedExperts.length>0 ? false : true)}
                            style={{ ...buttonStylesGreen(selectedExperts.length>0 ? false : true), ...{ width:device=='desktop'?'122px':'100%', } }}

                        >
                            Transmettre
                        </Button>
                    </div>
                </div>*/}
            </div>

            <div className='frame7TableMissionBDCAdmin'>
                <div className='frame8TableMissionBDCAdmin'>
                    <Button
                        className='frame29CvTheque'
                        onClick={() => {
                            navigate('.', { replace: true }
                            );
                        }}
                        style={{ ...buttonStyles(), ...{ background: '#E7EAF9', color: '#214DCE', borderRadius: '60px' } }}
                    >
                        {i18n.t('Candidatures')}
                    </Button>
                    <Button
                        className='frame31CvTheque'
                        onClick={() => {
                            navigate(`/${role}/ao/aoDetails/${param?.aoId}`, { replace: true }
                            );
                        }}
                        //style={notSelectedFrameCvTheque}
                        variant='text'
                        style={{ ...buttonStyles(), ...{ borderRadius: '60px' } }}
                    >
                        {i18n.t('Données AO')}
                    </Button>
                </div>
            </div>
            <MaterialTableComponent
                columns={ExpertsColumns}
                data={candidaturesArray}
                title="Candidatures"
                options={{
                    selection: true
                }}
                onRowClick={(event, rowData) => {
                    setSelectedRow(rowData?.tableData.id);
                }}
                selectedRow={selectedRow}
                //onSelectionChange={(rows) => {
                //    console.log('rows',{ rows });
                //    setSelectedExperts(rows);
                //}}
                // actions={[
                //     {
                //         icon: 'save',
                //         tooltip: 'Save User',
                //         onClick: (event, rowData) => alert('You saved ' + rowData.name)
                //     }
                // ]}
            />
            {
                openCvAnonyme &&
                <CvAnonyme
                    openCvAnonyme={openCvAnonyme}
                    setOpenCvAnonyme={setOpenCvAnonyme}
                    expert={expert}
                    titreAO={ao?.intitulePoste}
                    mode={'candidature'}
                    selectedCandidature={selectedCandidature}
                    refreshParentTable={refresh}
                    visualiseCvOnly={role == 'admin'}
                >
                    {/*//* I should send candidatureId rather than aoId :) */}
                    {(role !== 'admin' || role=='esn') &&
                        <ChangeStatusCandidature
                            width={'100%'}
                            //defaultStatusCandidat={expertStatut}
                            defaultStatusCandidat={statusCandidatures[selectedCandidature?.index]}
                            setStatusCandidature={newStatus => handleStatusChange(selectedCandidature?.index, newStatus)}
                            expertId={expertId}
                            aoId={ao?._id}
                        />}
                </CvAnonyme>
            }
            {openDialogCommentPriveCv &&
                <DialogCommentPriveCv
                    //* ARRAY de tt les comment dans la candidature OR only the authentificated one ?? (not showed to other collaborators of the company)
                    commentaires={selectedCandidature?.note}
                    openDialogCommentPriveCv={openDialogCommentPriveCv}
                    setOpenDialogCommentPriveCv={setOpenDialogCommentPriveCv}
                />}
            <DialogTransmettreCv
                openDialogTransmettreCv={openDialogTransmettreCv}
                setOpenDialogTransmettreCv={setOpenDialogTransmettreCv}
            />
            {  openDialogMatchingScore &&
                        <DialogMatchingScore
                            openDialogMatchingScore={openDialogMatchingScore}
                            setOpenDialogMatchingScore={setOpenDialogMatchingScore}
                            rowData={selectedCandidature}
                        />}
        </div>
    );
}